import { FetchContext } from '../fetch-context';
import { JudgingQuestion } from '../../models';
import { responseErrorHandler } from '../response-error-handler';

export const getJudgingQuestions: (
  fetchContext: FetchContext,
  awardId: number,
  accessToken?: string,
) => Promise<JudgingQuestion[]> = (fetchContext, awardId, accessToken) => fetch(`${fetchContext.baseUrl}/api/admin/awards/${awardId}/judging-questions`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<JudgingQuestion[]>(fetchContext.errorStore, response, 'get judging questions'));
